import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	statusIcon: {
		width: 12,
		height: 12,
		borderRadius: "100%",
		borderWidth: "2px",
		borderStyle: "solid",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[600]),
		borderColor: colors.gray[400]
	},
	statusIconActive: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600]),
		borderColor: colors.green[400]
	},
	statusIconAlert: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[500]),
		borderColor: colors.yellow[300]
	}
}))

export default useStyles
